export default __webpack_public_path__ + "static/media/spinner.71fc4ee9.svg";